import { makeStyles } from '@material-ui/core/styles';

const useFieldStyles = makeStyles((theme) => ({
  chip: {
    margin: 2,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    zIndex: 2,
  },
  root: {
    width: '100%',
    color: theme.palette.text.primary,
  },
  suffix: {
    marginLeft: '0.3rem',
  },
  tooltip: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },
}));

export default useFieldStyles;
